import { encode } from "js-base64";

interface IEmailMessageWithEMLAttachment {
  body: string;
  subject: string;
  to: string;
  accessToken: string;
}

const sendEML = async ({ body, subject, to, accessToken }: IEmailMessageWithEMLAttachment) => {
  const content = await getEMLBase64Content(accessToken);
  return await fetch("https://graph.microsoft.com/v1.0/me/sendMail", {
    method: "POST",
    headers: {
      "Authorization": accessToken,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      "message": {
        subject,
        "body": {
          "contentType": "Text",
          "content": body
        },
        "toRecipients": [
          {
            "emailAddress": {
              "address": to
            }
          }
        ],
        "attachments": [
          {
            "@odata.type": "#microsoft.graph.fileAttachment",
            "name": "submission.eml",
            "contentType": "message/rfc822",
            "contentBytes": content
          }
        ]
      }
    })
  })
};

const GetItem = async (accessToken: string): Promise<string> => {
  const itemId = Office.context.mailbox.item?.itemId as string;
  const convertedId = Office.context.mailbox.convertToRestId(itemId, Office.MailboxEnums.RestVersion.v1_0)
  const req = await fetch(`https://graph.microsoft.com/v1.0/me/messages/${convertedId}/$value`, {
    headers: { "Authorization": accessToken }
  })
  return await req.text()
};

const getEMLBase64Content = async (accessToken: string): Promise<string> => {
  const emlTextContent = await GetItem(accessToken);
  return encode(emlTextContent)
};

export default sendEML;
